import styled, { css } from 'styled-components';
import { sm, xs } from '@exonet/react-shared/lib/styled';

export const Icon = styled.div`
  display: flex;
  align-items: center;
  /* Center the icon against the content, so it stays aligned with the message
     when an action button makes the alert taller than a single line. */
  align-self: center;
  color: var(--text);
`;

export const Title = styled.div`
  font-weight: 600;
`;

const colors = (type) => {
  const prefix = `--alert-${type}`;

  return css`
    border-color: var(${prefix}-border);
    background-color: var(${prefix}-bg);

    ${Icon} {
      color: var(${prefix}-border);
    }
  `;
};

export const Alert = styled.div`
  display: flex;
  flex-flow: row;
  gap: var(--xs-padding-horizontal);
  padding: var(--xs-padding);
  margin-bottom: var(--xs-padding-vertical);
  color: var(--text);
  border: 1px solid;
  border-color: var(--text);
  border-radius: var(--border-radius);
  background-color: var(--bg);

  ${xs(css`
    padding: var(--lg-padding);
    margin-bottom: var(--lg-padding-vertical);
  `)}

  ${sm(css`
    margin-bottom: var(--xl-padding-vertical);
  `)}
  
  ${({ alertType }) => colors(alertType)}

  /* An alert with a title is a block of text: the icon belongs next to that
     title instead of in the middle of the block. */
  &:has(${Title}) ${Icon} {
    align-self: flex-start;
    min-height: calc(var(--line-height) * 1em);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: var(--xs-padding-vertical);
  word-break: break-word;
  flex: 1;
`;

export const Message = styled.div``;

export const Dismiss = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: inherit;
  display: flex;
  align-items: flex-start;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;
